import React, { Component } from "react";

import LayoutBackoffice from "../../header_footer/LayoutBackoffice";

import axios from "axios";

import PropTypes from "prop-types";

import {deleteDataonServer} from '../../../../components/utils/RequestsHelper';

import Modal from 'react-modal';

import { getAccessToken } from "../../../../components/utils/RequestsHelper";

import DetalhesEvento from "./DetalhesEvento";

import DetalhesInscricao from "./DetalhesInscricao";

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

const buttonInscricoesStyle = {
  float: 'right'
};
 
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement(document.getElementById('root'));

class Evento extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      evento: {},
      modalIsOpen: false,
      detalhesEventoIsOpen: true
    };

    this.openModal = this.openModal.bind(this); 
    this.closeModal = this.closeModal.bind(this);
    this.gerirInscricoesClicked = this.gerirInscricoesClicked.bind(this);
    
  }

  gerirInscricoesClicked() {
    console.log("carregou no botão");
    this.setState({detalhesEventoIsOpen: !this.state.detalhesEventoIsOpen});
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }
 
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  componentDidMount = () => {
    this.loadEvento();
  };

  editButtonClicked = () => {
    this.context.router.history.push("/backoffice/eventos/editar/"+this.state.evento.identifier);
  };

  deleteButtonClicked = () => {
    
    let promiseObj = deleteDataonServer('/api/noticiasEventos/' + this.props.match.params.identifier);
    promiseObj.then(response => {
        if (response !== undefined){
          this.context.router.history.push("/backoffice/eventos");
        }
    })
    .catch(err => {
        console.log(err);
    });

  };

  loadEvento = async () => {
    let identifier = this.props.match.params.identifier;

    let res = {};

    let token = getAccessToken();

    try {
      res = await axios.get("/api/noticiasEventos/backoffice/" + identifier, {
        headers: {
          "x-auth-token": token
        }
      });
    } catch (error) {
      console.log(error);
    }

    let evento = res.data.noticiaEvento;

    this.setState({ evento });
  };

  render() {


    return (
      <LayoutBackoffice>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Delete Modal"
        >
 
          <h4>Deseja apagar o Evento?</h4>
          
          <p>Se apagar, não poderá voltar atrás.</p>

          <div className=""> 
            <button
              onClick={this.deleteButtonClicked}
              className="backoffice-btn btn btn-outline-success"
              
            >Sim, Apagar</button>

            <button className="backoffice-btn btn btn-outline-danger" onClick={this.closeModal}>Cancelar</button>
          </div>
          
          
        </Modal>

        <div className="container backoffice-details">
          <div className="div-btn">
            <button
              type="button"
              className="backoffice-btn btn btn-outline-info"
              onClick={this.editButtonClicked}
            >
              Editar
            </button>
            <button
              type="button"
              className="backoffice-btn btn btn-outline-danger"
              onClick={this.openModal}
            >
              Apagar
            </button>

            <button
              style={buttonInscricoesStyle}
              type="button"
              className="backoffice-btn btn btn-outline-info"
              onClick={this.gerirInscricoesClicked}
            >
              {this.state.detalhesEventoIsOpen ? "Gerir Inscrições" :  "Detalhes Evento"}
            </button>
          </div>


          {this.state.detalhesEventoIsOpen === true ? 

            <DetalhesEvento evento={this.state.evento}></DetalhesEvento>

          : 
              
            <DetalhesInscricao evento={this.state.evento}></DetalhesInscricao>
                        
          }






        </div>
      </LayoutBackoffice>
    );
  }
}

export default Evento;

